import { withStyles } from '@material-ui/core';
import { compose } from 'ramda';
import { connect } from 'react-redux';

import withQuerySync from '@/hocs/withQuerySync';

import queryDuck from '../ducks/query';
import {
  getParkingLevelThreeWhitelistError,
  getParkingLevelThreeWhitelistIds,
  getParkingLevelThreeWhitelistTotalCount,
  isLoadingParkingLevelThreeWhitelist,
} from '../selectors';
import ParkingLevelThreeWhitelistPage from './component';
import styles from './styles';

const mapStateToProps = state => ({
  error: getParkingLevelThreeWhitelistError(state),
  parkingLevelThreeWhitelistIds: getParkingLevelThreeWhitelistIds(state),
  isLoading: isLoadingParkingLevelThreeWhitelist(state),
  totalCount: getParkingLevelThreeWhitelistTotalCount(state),
});

export default compose(
  withQuerySync(queryDuck),
  connect(mapStateToProps),
  withStyles(styles),
)(ParkingLevelThreeWhitelistPage);
